module.exports = __webpack_public_path__ + "public/SiteImages/beamer.svg?c68d2a68";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/beamer.svg
// module id = 1001
// module chunks = 8